import {axiosService} from "../axios.service";
import {urls} from "../../constants";


const clientsService = {
    getAllClients: (page) => axiosService.get(`${urls.clients.clientsR}?page=${page}`)
        .then(value => value.data),

    createClient: (data) => axiosService.post(urls.clients.clientsR, data).then((value) => value.data),

    deleteById: (id) => axiosService.destroy(`${urls.clients.clientsR}/${id}`),

    updateById: (id, data) => axiosService.patch(`${urls.clients.clientsR}/${id}`, data).then((value) => value.data),

    searchClients: (page, word, searchField = 'search') => {
        const params = new URLSearchParams({page: String(page)});
        if (!searchField || searchField === 'search') {
            params.set('search', word);
        } else {
            params.set(searchField, word);
        }
        return axiosService.get(`${urls.clients.clientsR}?${params.toString()}`)
            .then(value => value.data);
    },

    getAllCouriers: () => axiosService.get(`${urls.clients.clientsR}/couriers`)
        .then(value => value.data),

    getCommunicationMethods: () => axiosService.get(`${urls.clients.clientsR}/enums/communication-methods`)
        .then(value => value.data),
}

export {
    clientsService
}